import axios from "axios";
import React, { useEffect, useState } from "react";
import { Socket, io } from "socket.io-client";
import { useApp } from "../../context/app-context";
import yellowRedCardImg from "../../assets/yellowRedCard.png";
import ball from "../../assets/scorer.png";
// 2025
import penSaved from "../../assets/goalieSave.png";
import PlayerModal from ".././PlayerModal";
import { ArrowDownIcon } from "@heroicons/react/20/solid";
import swal from "sweetalert";
import DummyImg from "../../assets/user.png";

const SOCKET_URL = `${process.env.REACT_APP_SERVER_URL}`;
// const socket = io.connect(SOCKET_URL);

var socket = io(SOCKET_URL, { transports: ["websocket"] });

function TimeLine() {
  const [showDetails, setShowDetails] = useState(false);
  const { eachMatchData, setEachMatchData, liveMatch } = useApp();
  const [timeline, setTimeline] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [team_logo, setTeam_logo] = useState(DummyImg);

  const closeModal = () => setIsModalOpen(false);

  const matchId = liveMatch._id;

  useEffect(() => {
    socket.on("connect", () => {
      console.log("Connected to the server");
    });
    socket.on("stats-updated", (updatedMatch) => {
      console.log("Match updated:", updatedMatch);
      ArrangeStats(updatedMatch?.stats);
      // Handle the updated match data (e.g., update the state or UI)
    });
  }, []);

  useEffect(() => {
    getEachMatchData(
      `${process.env.REACT_APP_SERVER_URL}/api/match/${matchId}`
    );
  }, []);

  //   zoom

  const openPhotoModalFunc = (photo) => {
    setIsModalOpen(true);
    setTeam_logo(photo);
  };

  async function getEachMatchData(url) {
    try {
      const response = await axios.get(url);
      console.log("GET Match request successful");
      console.log(response.data.match);
      setEachMatchData(response.data.match);
      ArrangeStats(response.data.match.stats);
      console.log(eachMatchData);
    } catch (error) {
      console.error("Error making GET match request:", error);
      // Handle errors
    }
  }

  function ArrangeStats(Stats) {
    console.log(Stats);

    const data1 = ArrangeTeam1Stats(Stats);

    const data2 = ArrangeTeam2Stats(Stats);

    const combined = {
      team1: data1,
      team2: data2,
    };
    console.log("SortedMatchStats", combined);

    const matchTimeline = ArrangeTimelineFromBothTeams(combined);
    console.log("📊 Match Timeline:", matchTimeline);
    setTimeline(matchTimeline);
  }

  function ArrangeTeam2Stats(Stats) {
    const formattedOwnGoals = Stats?.team1?.ownGoals?.map((goal) => ({
      minute: goal.minute,
      scorer: goal.player,
      type: "ownGoals",
      _id: goal._id,
    }));

    // Convert regular goals with a type field too (optional)
    const formattedGoals = Stats?.team2?.goals?.map((goal) => ({
      minute: goal.minute,
      scorer: goal.scorer,
      assist: goal.assist,
      type: "goal",
      _id: goal._id,
    }));

    const allGoals = [...formattedGoals, ...formattedOwnGoals].sort(
      (a, b) => a.minute - b.minute
    );

    const team = Stats?.team2;
    const sortedYellowdCards = team?.yellowCards.sort(
      (a, b) => a.minute - b.minute
    );
    const sortedRedCards = team?.redCards.sort((a, b) => a.minute - b.minute);

    const sortedPenaltySaved = team?.penaltySaved.sort(
      (a, b) => a.minute - b.minute
    );

    const data = {
      goals: allGoals,
      yellowCards: sortedYellowdCards,
      redCards: sortedRedCards,
      penaltySaved: sortedPenaltySaved,
      totalGoals: team?.totalGoals,
    };
    console.log("team2 : ", data);
    return data;
  }

  function ArrangeTeam1Stats(Stats) {
    // For team1 goals
    const formattedOwnGoals = Stats?.team2?.ownGoals?.map((goal) => ({
      minute: goal.minute,
      scorer: goal.player,
      type: "ownGoals",
      _id: goal._id,
    }));

    const formattedGoals = Stats?.team1?.goals?.map((goal) => ({
      minute: goal.minute,
      scorer: goal.scorer,
      assist: goal.assist,
      type: "goal",
      _id: goal._id,
    }));

    const allGoals = [...formattedGoals, ...formattedOwnGoals].sort(
      (a, b) => a.minute - b.minute
    );
    const team = Stats?.team1;
    const sortedYellowdCards = team?.yellowCards.sort(
      (a, b) => a.minute - b.minute
    );
    const sortedRedCards = team?.redCards.sort((a, b) => a.minute - b.minute);
    const sortedPenaltySaved = team?.penaltySaved.sort(
      (a, b) => a.minute - b.minute
    );

    const data = {
      goals: allGoals,
      yellowCards: sortedYellowdCards,
      redCards: sortedRedCards,
      penaltySaved: sortedPenaltySaved,
      totalGoals: team?.totalGoals,
    };
    console.log("team1 : ", data);

    return data;
  }

  function ArrangeTimelineFromBothTeams(arrangedStats) {
    const {
      team1: {
        goals: team1Goals = [],
        yellowCards: team1Yellow = [],
        redCards: team1Red = [],
        penaltySaved: team1Penalty = [],
      } = {},
      team2: {
        goals: team2Goals = [],
        yellowCards: team2Yellow = [],
        redCards: team2Red = [],
        penaltySaved: team2Penalty = [],
      } = {},
    } = arrangedStats;

    const combinedTimeline = [
      ...team1Goals.map((item) => ({
        ...item,
        team: eachMatchData?.team1,
        teamLogo: eachMatchData?.team1logo,
        teamNumber: "team1",
      })),
      ...team2Goals.map((item) => ({
        ...item,
        team: eachMatchData?.team2,
        teamLogo: eachMatchData?.team2logo,
        teamNumber: "team2",
      })),
      ...team1Yellow.map((item) => ({
        ...item,
        type: "yellowCards",
        team: eachMatchData?.team1,
        teamLogo: eachMatchData?.team1logo,
        teamNumber: "team1",
      })),
      ...team2Yellow.map((item) => ({
        ...item,
        type: "yellowCards",
        team: eachMatchData?.team2,
        teamLogo: eachMatchData?.team2logo,
        teamNumber: "team2",
      })),
      ...team1Red.map((item) => ({
        ...item,
        type: "redCards",
        team: eachMatchData?.team1,
        teamLogo: eachMatchData?.team1logo,
        teamNumber: "team1",
      })),
      ...team2Red.map((item) => ({
        ...item,
        type: "redCards",
        team: eachMatchData?.team2,
        teamLogo: eachMatchData?.team2logo,
        teamNumber: "team2",
      })),
      ...team1Penalty.map((item) => ({
        ...item,
        type: "penaltySaved",
        team: eachMatchData?.team1,
        teamLogo: eachMatchData?.team1logo,
        teamNumber: "team1",
      })),
      ...team2Penalty.map((item) => ({
        ...item,
        type: "penaltySaved",
        team: eachMatchData?.team2,
        teamLogo: eachMatchData?.team2logo,
        teamNumber: "team2",
      })),
    ];

    const sortedTimeline = combinedTimeline.sort((a, b) => a.minute - b.minute);
    return sortedTimeline;
  }

  // delete
  const deleteMatchEvent = async ({ matchId, eventType, statId, team }) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/api/match/edit/${matchId}/event/${eventType}/${statId}/delete`,
        { team }
      );
      console.log("Event deleted successfully:", response.data);
      return response.data;
    } catch (err) {
      console.error("Error deleting event:", err);
      throw err;
    }
  };

  const deleteFunc = (event) => {
    const matchId = eachMatchData?._id;
    let eventType = event?.type;
    const statId = event?._id;
    const team = event?.teamNumber;

    //
    if (eventType == "goal") {
      eventType = "goals";
    }
    console.log("matchId", matchId);
    console.log("Type: ", eventType);
    console.log("event id : ", statId);
    console.log("team: : ", team);

    swal({
      title: "Are you sure?",
      text: "Once clicked on okay, event will be deleted !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        console.log("deleted");
        deleteMatchEvent({ matchId, eventType, statId, team });
      } else {
        swal("Event not deleted!");
      }
    });
  };

  //time line UI
  const renderCard = (event) => (
    <div key={event.id}>
      <PlayerModal
        isOpen={isModalOpen}
        onClose={closeModal}
        team_logo={team_logo}
      />
      <div className="w-full flex justify-center mb-2">
        <ArrowDownIcon className="w-6 h-6 " />
      </div>
      <span className="flex justify-center text-green-200 font-semibold text-lg ">
        {event?.minute}'
      </span>

      <div
        key={event.id}
        className="bg-white border shadow p-2 rounded-lg flex justify-between flex flex-col  max-w-xl "
      >
        {/* <div className="flex items-end text-green-600">{event.minute}'</div> */}
        <div className="bg-indigo-700 flex rounded-lg text-white mb-2 py-1 font-bold uppercase items-center justify-between">
          {/* {event?.team} */}

          {event?.type === "goal" && <img src={ball} className="mx-2 w-5" />}
          {(event?.type === "yellowCards" || event?.type === "redCards") && (
            <img src={yellowRedCardImg} className="mx-2 w-5" />
          )}
          {event?.type === "ownGoals" && (
            <>
              <span className="font-bold pl-1">(OG) </span>
            </>
          )}
          {event?.type === "penaltySaved" && (
            <img src={penSaved} className="mx-2 w-5" />
          )}
          {/* when event name ends with s removes s else display event name */}
          {event?.type?.endsWith("s") ? event.type.slice(0, -1) : event?.type}

          <span className="flex items-end text-green-600 mr-2 rounded-lg bg-white p-0.5">
            {/* {event?.minute}' */}
            <img
              src={event?.teamLogo}
              alt={event?.teamNumber}
              className="w-6 h-6 rounded-md  "
              onClick={() => openPhotoModalFunc(event?.teamLogo)}
            />
          </span>
        </div>
        {/* <div className="flex text-lg font-semibold justify-center uppercase items-center">
          {event.type} (
          <div className="flex items-end text-green-600">{event.minute}'</div>)
        </div> */}
        <div className="text-sm text-gray-700">
          {event?.type === "goal" && (
            <div className="flex gap-2 justify-between">
              <p>
                <strong>Scorer:</strong> {event?.scorer?.name}
              </p>
              {event?.assist?.name && (
                <p>
                  <strong>Assist:</strong> {event?.assist?.name}
                </p>
              )}
            </div>
          )}
          {event?.type === "ownGoals" && (
            <p>
              <strong>Own Goal By:</strong> {event?.scorer?.name}
            </p>
          )}
          {event?.type === "penaltySaved" && (
            <p>
              <strong>Saved By:</strong> {event?.player?.name}
            </p>
          )}
          {(event?.type === "yellowCards" || event?.type === "redCards") && (
            <p>
              <strong>Player:</strong> {event?.player?.name}
            </p>
          )}
        </div>

        <div
          className="bg-red-700 rounded-lg text-white mt-2 py-1 font-bold"
          onClick={() => deleteFunc(event)}
        >
          Delete
        </div>
      </div>
    </div>
  );
  return (
    <li className="flex w-full py-5">
      <details className="group w-full">
        <summary className="flex items-center justify-between gap-2 p-2 font-medium marker:content-none hover:cursor-pointer">
          <div
            className="flex justify-between w-full"
            onClick={() => setShowDetails(true)}
          >
            <div className="flex gap-5">
              <div className="min-w-0 flex-auto">
                <p className="text-xl sm:text-2xl md:text-4xl font-semibold leading-6  text-teal-600 ">
                  Timeline (Delete Events)
                </p>
              </div>
            </div>
          </div>
          <svg
            className="w-5 h-5 text-gray-500 transition group-open:rotate-90 self-center"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            ></path>
          </svg>
        </summary>
        <main className="m-5 place-content-center text-center border-emerald-50  border-b-2">
          <div className="max-w-xl mx-auto p-4 space-y-6 bg-teal-600 rounded-md mb-2">
            <h2 className="text-2xl font-bold mb-4">Match Timeline</h2>
            <div className="space-y-2">
              {timeline?.map((event) => renderCard(event))}
            </div>
          </div>
        </main>
      </details>
    </li>
  );
}

export default TimeLine;
